import { createFileRoute } from '@tanstack/react-router'

import { SetPasswordForm } from '@/features/auth/components/set-password-form'

/**
 * The invitation link page. The path is compiled into the backend
 * (`auth.frontend.set_password_path`) — renaming it 404s every invitation email.
 */
export const Route = createFileRoute('/set-password')({
  component: () => (
    <SetPasswordForm
      title="Setup your password"
      submitLabel="Save Password"
      confirmation={{
        title: 'Password saved',
        description: 'Your password has been successfully setup',
        actionLabel: 'Log In',
      }}
    />
  ),
})
